export default __webpack_public_path__ + "static/media/filter_icon_meeting_room.2702c9a6.svg";